import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const flamelinkFBConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

// FIREBASE SETTINGS
export const fbInit = (connectionString, project) =>
  firebase.initializeApp(connectionString || flamelinkFBConfig, project);

fbInit();

// const fs = firebase.firestore();
export const db = firebase.firestore();
export const auth = firebase.auth();

db.settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
});

db.enablePersistence().catch(function (err) {
  console.error({ err });
  if (err.code === "failed-precondition") {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code === "unimplemented") {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
});

export default {
  fbInit,
  db,
  auth,
  authObj: firebase.auth,
};
